<template>
  <div class="wrapper">

    <div class="account-head-title">
      账号信息
    </div>
    <div class="account-head">

      <div class="account-wrapper">

        <div class="content-wrapper">
          <div class="title">注册账号:</div>
          <div class="content">{{ this.getUserInfo.account }}</div>
        </div>

      </div>

      <div class="account-wrapper" @click="changePwd">

        <div class="content-wrapper">
          <div class="title">账户密码:</div>
          <div class="content">***********</div>
        </div>

        <div class="buttonWrapper" id="changPwd">

          <div class="button-icon">
            <svg class="icon" aria-hidden="true">
              <use xlink:href="#icon-xiugai"></use>
            </svg>
          </div>

          <div class="button-content">
            修改密码
          </div>

        </div>

      </div>

      <div class="account-wrapper">

        <div class="content-wrapper">
          <div class="title">绑定手机号:</div>
          <div class="content">{{ this.getUserInfo.phoneNum }}</div>

        </div>
        <div @click="changePhone" class="buttonWrapper" id="changPhone">

          <div class="button-icon">
            <svg class="icon" aria-hidden="true">
              <use xlink:href="#icon-xiugai"></use>
            </svg>
          </div>

          <div class="button-content">
            修改手机号
          </div>

        </div>
      </div>

      <el-dialog title="修改密码" :visible.sync="pwdDialogFormVisible">
        <el-form>
          <el-form-item label="原始密码">
            <el-input type="password" v-model="oldPwd" autocomplete="off" show-password></el-input>
          </el-form-item>
          <el-form-item label="新密码">
            <el-input type="password" v-model="newPwd" autocomplete="off" show-password></el-input>
          </el-form-item>
          <el-form-item label="再次输入新密码">
            <el-input type="password" v-model="newPwd2" autocomplete="off" show-password  @blur="checkPwd" ></el-input>
          </el-form-item>

        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="pwdDialogFormVisible = false">取 消</el-button>
          <el-button type="primary" @click="checkAndUpdatePwd" >确 定</el-button>
        </div>
      </el-dialog>

      <el-dialog title="修改手机号" :visible.sync="phoneDialogFormVisible">
        <el-form label-position="left">
          <el-form-item label="手机号码">
            <el-input v-model="phoneNumber" autocomplete="off" style="width: 20vw"></el-input>
          </el-form-item>
          <el-form-item label="验证码">
            <el-input v-model="checkCode" autocomplete="off" style="width: 15vw"></el-input>
            <el-button type="primary" plain @click="checkCodeClick">获取验证码</el-button>
          </el-form-item>

        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="phoneDialogFormVisible = false">取 消</el-button>
          <el-button type="primary" @click="changePhoneNumber">确 定</el-button>
        </div>
      </el-dialog>


    </div>

    <div class="center">
      <div class="account-head-title">
        基本信息
      </div>

      <el-row>
        <el-button type="primary" @click="updateAccount()">保存</el-button>
      </el-row>

    </div>


    <div class="form-wrapper">

      <div class="form">
        <el-form label-width="8vw" :model="formLabelAlign">

          <el-form-item label="昵称:">
            <el-input v-model="formLabelAlign.nickName" placeholder="请输入昵称"></el-input>
          </el-form-item>

          <el-form-item label="公司名称:">
            <el-input v-model="formLabelAlign.companyName" placeholder="请输入公司名称"></el-input>
          </el-form-item>

          <el-form-item label="公司网址:">
            <el-input v-model="formLabelAlign.companyWebsite" placeholder="请输入公司网址"></el-input>
          </el-form-item>

          <el-form-item label="联系邮箱:">
            <el-input v-model="formLabelAlign.email" placeholder="请输入公司邮箱"></el-input>
          </el-form-item>

        </el-form>

      </div>


    </div>

  </div>
</template>

<script>

import {regionData, CodeToText} from "element-china-area-data";

import {getCheckCode, checkPhoneRegister, changePhone,updatePwd,updateAccountInfo} from '../../api/userMG.js'

import {mapState,mapGetters} from 'vuex'


export default {
  data() {
    return {
      formLabelAlign: {
        account:"",
        phoneNum:"",
        name:"",
        nickName:"",
        companyName:"",
        companyWebsite:"",
        email:""
      },
      options: regionData,
      selectedOptions: [],
      pwdDialogFormVisible: false,
      phoneDialogFormVisible: false,
      oldPwd: "",
      newPwd: "",
      newPwd2: "",
      phoneNumber: "",
      checkCode: ""

    }
  },
  // 注册组件
  components: {},


  /**
   * 创建完毕
   */
  created() {

    console.log(123);
    console.log(this.getUserInfo)

    for(let key in this.getUserInfo) {
      this.formLabelAlign[key] = this.getUserInfo[key];
    }


  },

  computed: {
    ...mapGetters([
      'getUserInfo',
    ])

  },


  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {

    handleChange() {
      let loc = "";
      for (let i = 0; i < this.selectedOptions.length; i++) {
        loc += CodeToText[this.selectedOptions[i]];
      }
      alert(loc);
    },
    changePhone() {
      this.phoneDialogFormVisible = true;
    },
    changePwd() {
      this.pwdDialogFormVisible = true;
    },
    checkPwd(){

      if (this.newPwd!=this.newPwd2 && this.newPwd2){
        this.$message.warning("两次输入的密码不一致!")
      }
    },
    checkCodeClick() {
      let that = this;
      if (!this.checkPhone(this.phoneNumber)) {
        this.$message.warning("手机号码不正确,请输入正确的手机号码")
      } else {
        checkPhoneRegister(this.phoneNumber).then(function (response) {

          if (response.status != 200) {
            that.$message.error("手机号码错误")
          } else {

            if (response.data) {
              that.$message.error("该手机号已注册")
            } else {
              getCheckCode(that.phoneNumber);
              that.$notify({
                title: '成功',
                message: '短信已发送',
                type: 'success'
              });
            }

          }

        }).catch(e => {
          console.log(e);
          this.$message.error("网络错误，请稍后重试")
        })


      }


    },
    checkPhone(num) {
      return /^1[3456789]\d{9}$/.test(num);
    },
    changePhoneNumber() {



      changePhone({
        "account": this.getUserInfo.account,
        "phone": this.phoneNumber,
        "smsCode": this.checkCode

      }).then(response => {

        if (response.status != 200) {
          this.$message.error(response.message);
        } else {
          this.$message.success("手机号码修改成功！");

          let user = this.$store.state.user;
          user.phoneNum = this.phoneNumber;
          this.$store.commit("setUserInfo", user);
        }
        this.phoneDialogFormVisible = false;

      }).catch(e => {
        console.log(e)
      })


    },
    checkAndUpdatePwd(){

      const pwdRegex = new RegExp('(?=.*[0-9])(?=.*[a-zA-Z])(?=.*[^a-zA-Z0-9]).{8,30}');
      if (!this.oldPwd || !this.newPwd || !this.newPwd2){
        this.$message.error("输入的信息不能为空");
      }else{

        if (!pwdRegex.test(this.newPwd)) {
          this.$message.warning("密码中必须包含字母、数字、特称字符，至少8个字符，最多30个字符");
        }
      }


      if(this.newPwd!=this.newPwd2){
        this.$message.warning("两次输入的密码不一致");
      }



      let that = this;

      updatePwd(
        {
          "account":this.getUserInfo.account,
          "oldPwd":this.oldPwd,
          "newPwd":this.newPwd2
        }
      ).then(response=>{

        if (response.status!=200){
          that.$message.warning(response.message)
        }else{
          that.$message.success("密码修改成功")
        }

      }).catch(e=>{
        that.$message.error("网络异常，请稍后重试");
        console.log(e)
      })

    },

    updateAccount(){
      let that = this;
      updateAccountInfo(this.formLabelAlign).then(response=>{

        if (response.status==200){
          that.$message.success("更新成功");

          that.$store.commit("setUserInfo",response.data);


        }else{
          that.$message.error(response.message);
        }

      }).catch(e=>{
        console.log(e);
        that.$message.error("网络异常请稍后重试");
      })

    }
  }
}
</script>

<style scoped>
.wrapper {
  margin: 0 2vw;
}
.el-form-item{
  margin: 3vw 0;
}

.account-head {
  background-color: #ffffff;
  display: flex;
  justify-content: center;
  align-content: center;

}

.account-wrapper {
  width: 30vw;
  height: 10vw;
  display: flex;
  align-items: center;
  margin: 0 3vw;
}

.buttonWrapper {
  display: flex;
  /*border: 0.1vw black solid;*/
  padding: 0.2vw 1.0vw;
  margin-top: 3vw;
  margin-left: 2vw;
  overflow: hidden;
  font-size: 0.8vw;
  cursor: pointer;
  color: white;

  border-radius: 0.2vw;
  height: 1.5vw;
  justify-content: center;
  align-items: center;
}
#changPhone{
  background-color: #E67470;
}
#changPwd{
  background-color: #3A90F7;
}


.account-head-title {
  font-size: 1vw;
  margin: 1vw 0;
  font-weight: 700;

}

.content-wrapper .title {
  margin: 1vw auto;
}

.form-wrapper {
  background-color: #ffffff;
  height: 35vw;
}

.form {
  padding-top: 3vw;
  width: 30vw;
}

.center {
  display: flex;
  justify-content: space-between;
  margin: 1vw 0;
}

</style>






// WEBPACK FOOTER //
// src/views/account/Account.vue